import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sdc-app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class SidebarComponent implements OnInit {
  readRecordRoles: boolean;
  maintainRecordType1Roles: boolean;
  createRecordType2Roles: boolean;
  editRecordType2Roles: boolean;
  deleteRecordType2Roles: boolean;
  createRecordType3Roles: boolean;
  editRecordType3Roles: boolean;
  deleteRecordType3Roles: boolean;
  createRecordType4Roles: boolean;
  editRecordType4Roles: boolean;
  userName: string;
  role: string;
  isAdmin: boolean;
  isAttendanceUser: boolean;

  constructor() { }

  ngOnInit(): void {
    this.isAdmin = false;
    this.isAttendanceUser = false;
    this.userName = JSON.parse(localStorage.getItem('currentUser')).userName;
    this.role = JSON.parse(localStorage.getItem('currentUser')).role;
    
    if (this.role == 'Admin') {
      this.isAdmin = true;
    } else if (this.role == 'Attendance') {
      this.isAttendanceUser = true;
    }
    
    this.readRecordRoles = true;
    this.maintainRecordType1Roles = true;
    this.createRecordType2Roles = true;
    this.createRecordType3Roles = true;
    this.createRecordType4Roles = true;
    this.deleteRecordType2Roles = true;
    this.deleteRecordType3Roles = true;
    this.editRecordType2Roles = true;
    this.editRecordType3Roles = true;
    this.editRecordType4Roles = true;
  }
}
